/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {StopTimecardBreakRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {StopTimecardBreakResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const stopTimecardBreak = (request: StopTimecardBreakRequest, options?: CashRequestOptions) => post<StopTimecardBreakRequest, StopTimecardBreakResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/StopTimecardBreak", request, {...options, rejectOnError: true })